<template>
  <section class="hero">
    <h1>{{ title }}</h1>
    <h2 v-if="subtitle">
      <slot name="subtitle">{{ subtitle }}</slot>
    </h2>
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'PageHero',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
.hero {
  text-align: left;
  padding: 2rem 0 3rem;
  margin-bottom: 2rem;
}

.hero h1 {
  color: var(--color-white);
  font-size: var(--font-size-hero);
  font-weight: bold;
  line-height: var(--line-height-tight);
  margin: 0;
  text-shadow: var(--shadow-text);
}

.hero h2 {
  color: var(--color-white);
  font-size: 2rem;
  line-height: var(--line-height-tight);
  margin: 0;
  text-shadow: var(--shadow-text);
}

.hero h2 a {
  color: var(--color-white);
  text-decoration: none;
}

.hero h2 a:hover {
  text-decoration: underline;
}

/* Large hero variant (for home page) */
.hero.large h1 {
  font-size: var(--font-size-hero-large);
}

@media (max-width: 768px) {
  .hero {
    padding: 1.5rem 0 2rem;
  }

  .hero h1 {
    font-size: 1.8rem;
  }

  .hero h2 {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .hero h1 {
    font-size: 1.5rem;
  }

  .hero h2 {
    font-size: 1.2rem;
  }
}
</style>
